import { Option, useModal, useThemePerClass } from '@afterpaytouch/core'
import React, { FC } from 'react'
import { useGetAutoPayStatusChangeHandler, useGetIsAutoPayAgreed, useIsAutoPayButtonEligibleSession } from './hooks'
import { useMonitoringWithEnduringEventProperties } from '../../integrations/monitoring'
import { TrackingEvent, AutoPayModalKey } from '../../model'
import { AutopayModal } from './AutopayModal'
import { AutopayButtonToggleText } from './AutopayButtonToggleText'
import styles from './styles.module.css'

// Used for PM & Cash PBI
export const AutopayButton: FC = () => {
  const autoPayAgreed = useGetIsAutoPayAgreed()
  const { logEvent } = useMonitoringWithEnduringEventProperties()
  const { visible, closeModal, showModal } = useModal(AutoPayModalKey)
  const statusChangeHandler = useGetAutoPayStatusChangeHandler('value')
  const isAutoPayEligibleSession = useIsAutoPayButtonEligibleSession()
  const themeClass = useThemePerClass(styles)

  if (!isAutoPayEligibleSession) {
    return null
  }

  return (
    <div className={themeClass.autopayOptionWrapper}>
      <Option
        onClick={() => {
          logEvent(TrackingEvent.PRESSED_SUMMARY_PAGE_AUTOPAY)
          showModal()
        }}
        testNameSpace='autopay'
        stretch
        text={<AutopayButtonToggleText />}
      />
      <AutopayModal show={visible} onCloseModal={closeModal} onAutopayStatusChange={statusChangeHandler} autoPayAgreed={autoPayAgreed} />
    </div>
  )
}
